export const getYoutubeId = (url: string) => {
	const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
	const match = url.match(regExp);

	if (!match || match[2].length !== 11) {
		throw new Error('Could not retrieve id from youtube-video source');
	}
	return match[2];
};
